module.exports = __webpack_public_path__ + "img/13.f0a1f113.png";